export type DateFormat =
  | "date-time-realtime"
  | "DD/MM/YYYY"
  | "MM/DD/YYYY"
  | "date-short";

export function formatEpoch(epoch: number, format: DateFormat = "DD/MM/YYYY") {
  return formatDate(new Date(epoch * 1000), format);
}

export function formatDate(date: Date, format = "DD/MM/YYYY") {
  if (format === "date-time-realtime") {
    return date.toLocaleString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  if (format === "DD/MM/YYYY") {
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  if (format === "date-short") {
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  return date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
